import PropTypes from 'prop-types';

import FloatingDateInput from '#/modules/commonComponents/form/FloatingDateInput';
import FloatingTextarea from '#/modules/commonComponents/form/FloatingTextarea';

/**
 * 出庫表單 header：出庫日／事由／備註（出庫類別固定 payload，UI 不顯示）。
 */
const WorkOrderOutboundDraftPanel = ({
  control,
  register,
  errors,
  disabled = false,
}) => (
  <section className="form-section @container/form-section min-w-0">
    <h3 className="form-subsection__title mb-4">出庫資訊</h3>

    <div className="mb-3 grid grid-cols-1 gap-3 @4xl/sheet:grid-cols-2">
      <FloatingDateInput
        id="issueDate"
        label="出庫日"
        control={control}
        errors={errors}
        disabled={disabled}
      />
    </div>

    <div className="grid grid-cols-1 gap-3 @4xl/sheet:grid-cols-2">
      <FloatingTextarea
        id="issueReason"
        label="出庫事由"
        register={register}
        errors={errors}
        rows={2}
        disabled={disabled}
      />
      <FloatingTextarea
        id="remark"
        label="備註"
        register={register}
        errors={errors}
        rows={2}
        disabled={disabled}
      />
    </div>

    {errors?.lines?.message ? (
      <p className="mt-2 text-sm text-destructive">{errors.lines.message}</p>
    ) : null}
    {errors?.lines?.root?.message ? (
      <p className="mt-2 text-sm text-destructive">{errors.lines.root.message}</p>
    ) : null}
  </section>
);

WorkOrderOutboundDraftPanel.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
};

export default WorkOrderOutboundDraftPanel;
